import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { deleteCustomerContacts } from '../customers'

export default function useCustomerContactDelete() {
  const queryClient = useQueryClient()

  const { mutate, isLoading } = useMutation(deleteCustomerContacts, {
    onSuccess: () => {
      queryClient.invalidateQueries(`customerContacts`)
      notification.success({
        message: 'Sucesso!',
        description: 'Remoção realizado com sucesso!'
      })
    },
    onError: () => {
      notification.error({
        message: 'Erro',
        description: 'Não foi possível remover!'
      })
    }
  })

  return { mutate, isLoading }
}
